<div class="home" data-testid="decim-home-container">
  <div class="top">
    <div class="top-bg">
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/aber/aber-logo.webp" height="85px" />
      <div class="top-content">
        <h1>Plateforme numérique nationale</h1>
        <p>pour la planification, l’appel d’offres et le suivi des programmes de mini-réseaux</p>
      </div>
    </div>
  </div>

  <div class="middle">
    <div class="content content-left">
      <h2>Nos Realisations</h2>
      <p>Plus de 41 milliards de francs CFA mobilisés et mis en œuvre ; 349 localités électrifiées ; Plus de 41 000 abonnés permettant à plus 250 000 personnes de bénéficier des services modernes de l’électricité ; La réduction des coûts de construction des</p>
      <div class="image-container"></div>
    </div>
    <div class="content content-right">
      <h2>Nos Projets</h2>
      <p>Conseil de l’Entente : Projet pilote d’électrification par SHS d’une localité paran ;
        Cout : 50 millions par an; 3 localités réalisées dont une en cours : Sampopo, Dguifoloma, Zoumahiri (plus de 500kits déployés et 350 en cours).</p>
      <div class="image-container"></div>
    </div>
  </div>


  <h1>En collaboration avec</h1>
  <div class="bottom">
    <div class="bottom-logo-box">
      <div class="bottom-logos">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/aber/pnud.webp" width="392px" />
      </div>
    </div>
    <div class="bottom-logo-box">
      <div class="bottom-logos">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/aber/asdi.png" width="340px" />
      </div>
    </div>
  </div>
</div>
